import React from 'react';
import { Grid } from '@material-ui/core';
import * as Unicons from '@iconscout/react-unicons';
import {connect} from 'react-redux';
import {closeMenu}from './../../actions/menu';
import {startLogoutUser} from './../../actions/user';
import {withRouter,Link} from 'react-router-dom';
import {authService} from "./../../services/authService";
import { slide as Menub } from 'react-burger-menu';
import { IDENTITY_CONFIG } from "../../utils/authConst";
import avatar from "./../../assets/images/avatar_1.png";
import Img from 'react-image';

 class Menu extends React.Component{
      constructor(props){
        super(props);
        this.state={
            isAdmin:false
        }
     }
     componentDidMount = async () =>{
        this.setState({isAdmin : await authService.userHasPermission("Atency.PersonnelAPI.DeletePersonnel")});
    }
     handlelogOut = async () => {
        await this.props.startLogoutUser();
        this.props.history.push('/login');

    }
      menuToggle = (state) => { 
        if(!state.isOpen){
            this.props.closeMenu();
        }
      }
      closeMenu = () => {
        this.props.closeMenu();
      }
    
      render () { 
        return (
          <Menub right isOpen={ this.props.menu.show } onStateChange={this.menuToggle}>
               <Grid container className="py-4 px-3 bb-1 focus-reset menu-user-container">
                     <Grid item xs={4} className="d-flex">
                     <Img alt="" className="text-center mx-auto  user-profie-pic"
                                src={[(localStorage.getItem("subDomain")!==null ? IDENTITY_CONFIG.protocol+localStorage.getItem("subDomain")+"."+IDENTITY_CONFIG.baseUrl+"/API/ProfileAPI/GetPersonnelProfilePicture?imageName="+localStorage.getItem("userImage"):''),
                                    avatar]}
                            />
                  
                     </Grid>
                     <Grid item xs={8} className="pr-2">
                         <p className="mt-1 text-primary" >{localStorage.getItem("userFullName")} </p>
                         <p className="my-auto text-secondary" > {localStorage.getItem("userPersonnelCode")} </p>
                     </Grid>
              
                 </Grid>
            <Link onClick={this.closeMenu} to="/" className={this.props.history.location.pathname === "/" ? "selected menu-item" :"menu-item"}><Unicons.UilHomeAlt size="25"  />خانه</Link>
            {this.state.isAdmin ? <Link onClick={this.closeMenu}  to="/subordinates" className={this.props.history.location.pathname === "/subordinates" ? "selected menu-item" :"menu-item"}><Unicons.UilChart size="25"   />کارکرد</Link> : ''}
            <li className="menu-item bt-1 mt-1 cursor-pointer"  onClick={this.handlelogOut}><Unicons.UilExit size="25" />خروج</li>
          </Menub>
        );
      }
}
const mapToStateProps = (state) => {
    return state;
}
const mapDispatchToProps = {
    closeMenu,
    startLogoutUser
}
export default withRouter(connect(mapToStateProps , mapDispatchToProps)(Menu))